import React, { useEffect, useState } from 'react';
import { useFetch } from '../../../utils/hooks/useFetch';
import { ContactUsApi } from '../../../api/base/ContactUs';
import { useParams } from 'react-router';
import { useCommonStyles } from '../../../materialConfig/commonStyles';
import { makeStyles } from "@material-ui/core/styles";
import { AuthorCard } from './AuthorCard';
import { BaseTypography } from "src/components/common";
import { ExpertiseBadge } from './ExpertiseBadge';

const useStyles = makeStyles((theme) => ({
  root: {
      padding: '50px 20px'
  },
  heading:{
      textDecoration: "underline",
      margin: "0 0 20px"
  },
  list:{
      fontSize: "1rem",
      listStyle: "auto",
      margin: "0 0 10px"
  },
  title:{
    color: "#000"
  }
}));

export const AuthorNews: React.FC = () => {
  const params:any = useParams();
  const [{ response, isLoading }, doFetch] = useFetch(
    ContactUsApi.getAuthorNews,
  );
    
    useEffect(() => {
      doFetch(params.id);
    }, [doFetch]);
    
    const commonClasses = useCommonStyles();
    const classes = useStyles();  

    return (
      <div className={`${commonClasses.container} ${classes.root}`}>
          <BaseTypography gutterBottom="true" variant="h2">
            Expert - {params.name.split("-").join(" ")}
          </BaseTypography>
          <ExpertiseBadge />
          {response?.data?.length  ? <AuthorCard response={response?.data} /> : ""}
		  {!response?.data?.length && <h4>No posts found for this expert</h4>}
      </div>
    )
}